import { Stack, Typography, Switch } from "@mui/material";
import { ChangeEvent, useCallback } from "react";
import { useUpdatePharmacyStateMutation } from "src/api/services/pharmacyApi";
import { PharmacyState as PharmacyStateType } from "src/api/types";

interface Props3 {
  state: PharmacyStateType & { name: string };
  disabled: boolean;
}
const PharmacyState = ({ state, disabled }: Props3) => {
  const [updatePharmacyState] = useUpdatePharmacyStateMutation();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      updatePharmacyState({
        pharmacyId: state.pharmacy_id,
        stateCode: state.state_code,
        body: {
          active: event.target.checked,
        },
      });
    },
    [state.pharmacy_id, state.state_code, updatePharmacyState]
  );

  return (
    <Stack
      pt={1}
      pb={1}
      width={"300px"}
      direction="row"
      alignItems="center"
      role="group"
      justifyContent="space-between"
    >
      <Typography variant="h6" id={`label-${state.state_code}`}>
        {state.name}
      </Typography>
      <Switch
        color="secondary"
        checked={state.active}
        disabled={disabled}
        onChange={handleChange}
      />
    </Stack>
  );
};

export default PharmacyState;
